import { render, staticRenderFns } from "./RejectApprovalDialog.vue?vue&type=template&id=0930b619"
import script from "./RejectApprovalDialog.vue?vue&type=script&lang=js"
export * from "./RejectApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports